// 默认中文引导 Prompt（用户可在工具栏“编辑 Prompt”中修改，会话内有效）
export const DEFAULT_PROMPT = `你是一名文本审阅助手。下面是一份带有 CriticMarkup 批注的 Markdown 文档，请根据批注修改文档，并输出修改后的完整 Markdown：
- \`{++ 文字 ++}\` 建议插入的新内容
- \`{-- 文字 --}\` 建议删除的内容
- \`{~~ 旧 ~> 新 ~~}\` 建议把“旧”替换为“新”
- \`{== 文字 ==}\` 需重点关注的部分
- \`{>> 备注 <<}\` 审阅意见

请保留未批注部分的原始结构，仅按批注调整，输出完整文档。

文档如下：`;
